import React from 'react'
import '../../styles/services.css';

function NetworkService(){
    return(
        <div className="sub_page_wrapper page_content">
            <h3>Network and Infrastructure</h3>
            <p>Smart Khalanga Solutions (Pty) Ltd has expertise in new site surveys including
            network and infrastructure planning of computer and network (Voice and Data)
            cabling installations, installation of servers, cabling from switches to LAN points
            and/ or WIFI modems.</p>

            <p>
            Our engineers major in the installation of structured cabling such as Cat5e, Cat6,
            Cat6a, 10Gb, voice and Fibre Optic Cabling terminating at servers and switches.
            This includes the management there of during day-to-day operations.
            </p>

            <p>
            Server management form an integral part of our portfolio. We possess skills in
            configuration, virtual and physical management including the installation of complex
            software and the distribution of security updates, patches and release management.
            </p>

            <p>
            Our expertise extends to Data Centre (DC) infrastructure management, through the
            use of specialized software and hardware to monitor and ensure adequate
            capacity is available to maintain the DC critical system and connections.
            </p>
        </div>
    )
}

export default NetworkService